import { consumeRecoverySnapshot } from "@/lib/stability/sessionRecovery";

/**
 * Restore minimal user context after an auto-recovery reload.
 * Runs once during startup; safe no-op when no snapshot exists.
 */
export function bootstrapRecoveryRestore() {
  if (typeof window === "undefined") return;
  const snap = consumeRecoverySnapshot();
  if (!snap) return;
  try {
    if (snap.matchId) localStorage.setItem("ss2026_active_match_id", snap.matchId);
    if (snap.language) localStorage.setItem("ss2026_language", snap.language);
    if (snap.nation) localStorage.setItem("ss2026_selected_nation", snap.nation);
    if (snap.activeTab) sessionStorage.setItem("ss2026_active_tab", snap.activeTab);
    const current = window.location.pathname + window.location.search + window.location.hash;
    if (snap.path && snap.path !== current && snap.path.startsWith("/")) {
      window.history.replaceState({}, "", snap.path);
    }
  } catch {
    /* storage blocked — ignore */
  }
}